import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { ICloud, IExtension, IHost, ITheme, IUser } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/users';
const $urlResources = '/admin/users/actions/resources';
const $urlResourceAdd = '/admin/users/actions/resourceAdd';

interface IGetRequest {
  id: string;
  keyword: string;
  offset: number;
  limit: number;
}

interface IGetResult {
  items: IUser[];
  count: number;
}

interface IResourcesResult {
  hosts: IHost[];
  cloud: ICloud;
  themes: ITheme[];
  extensions: IExtension[];
}

export interface IResourceAddRequest {
  userId: number;
  resourceType: string;
  extensionId: string;
  themeId: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
        utils.scrollTop();
      });
  },

  submit(req: IUser, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(userId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          userId,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  resources(userId: number, success: (res: IResourcesResult) => void) {
    utils.loading(true);
    request
      .post($urlResources, {
        userId,
      })
      .then((response: AxiosResponse<IResourcesResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  resourceAdd(req: IResourceAddRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlResourceAdd, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
